<template>
  <b-container fluid class="p-4 bg-white rounded shadow-sm">
    <!-- <b-alert show variant="primary" class="d-flex align-items-center">
      <strong class="mr-1">Sign *</strong> : Mandatory (Must Fill)
    </b-alert> -->

    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col md="6">
          <b-form-group label="Category *">
            <v-select
              id="maintenance_component_id"
              v-model="form.maintenance_component_id"
              required
              placeholder="Select Component Equipment"
              label="component_name"
              :options="options.category"
              :reduce="(opt) => opt.id"
              :disabled="$route.query?.maintenance_component_id"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Equipment Name *">
            <v-select
              v-model="form.maintenance_master_id"
              required
              placeholder="Select Equipment name"
              :disabled="!form.maintenance_component_id"
              label="equipment_name"
              :options="options.equipments"
              :reduce="(opt) => opt.id"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Job Name *">
            <b-form-input
              v-model="form.name"
              required
              placeholder="Enter job name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Job Code *">
            <b-form-input v-model="form.code" required />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Job Class *">
            <v-select
              v-model="form.maintenance_job_class_id"
              required
              placeholder="Select Job Class"
              :options="options.jobClass"
              label="jobClass"
              :reduce="(opt) => opt.id"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Job Type *" class="mb-2">
            <v-select
              v-model="form.maintenance_job_type_id"
              required
              placeholder="Select Job Type"
              :options="options.jobType"
              label="description"
              :reduce="(opt) => opt.id"
            />
          </b-form-group>
          <div
            class="d-flex align-items-center"
            v-if="form.maintenance_job_type_id == 12"
          >
            <b-form-checkbox id="is_reset" v-model="form.is_reset" />
            <label for="is_reset" class="mb-0">Reset Running Hours</label>
          </div>
        </b-col>
        <!-- Remarks -->
        <b-col md="12">
          <b-form-group label="Attachment">
            <b-form-file v-model="form.file" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Method *">
            <b-form-radio-group
              v-model="form.method"
              :options="[
                { text: 'Calendar Trigger', value: 'CALENDAR' },
                { text: 'Counter Trigger', value: 'COUNTER' },
              ]"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group v-if="form.method === 'COUNTER'" label="Engine Type *">
            <v-select
              v-model="form.power_type_ids"
              required
              multiple
              placeholder="Select Engine Type"
              :options="options.powerTypes"
              label="text"
              :reduce="(opt) => opt.value"
            >
              <template v-slot:option="option">
                <div
                  :class="{
                    'text-primary font-weight-bold':
                      form.power_type_ids &&
                      form.power_type_ids.includes(option.value),
                  }"
                >
                  <i
                    v-if="
                      form.power_type_ids &&
                      form.power_type_ids.includes(option.value)
                    "
                    class="fas fa-check text-success mr-2"
                  ></i>
                  {{ option.text }}
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col v-if="form.method === 'CALENDAR'" md="6">
          <b-form-group label="Calendar Type *">
            <b-form-select
              v-model="form.calendar_type"
              :options="['DAY', 'WEEK', 'MONTH', 'YEAR']"
              required
            />
          </b-form-group>
        </b-col>
        <b-col v-if="form.method === 'CALENDAR'" md="6">
          <b-form-group label="Calendar Interval *">
            <template #prepend></template>
            <b-form-input
              type="number"
              min="1"
              v-model="form.calendar_interval"
              required
            />
          </b-form-group>
        </b-col>

        <b-col md="12" v-if="form.method === 'COUNTER'">
          <label class="font-weight-bold mb-2">Counter Triggers</label>
          <div>
            <table class="table table-bordered align-middle">
              <thead class="thead-light">
                <tr>
                  <th style="width: 45%">Engine Name</th>
                  <th style="width: 35%">Interval</th>
                  <th style="width: 10%" class="text-center">
                    <i
                      class="fa fa-plus text-primary cursor-pointer"
                      @click="addCounterTrigger"
                    ></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(trigger, index) in form.counter_triggers"
                  :key="index"
                >
                  <td>
                    <v-select
                      v-model="trigger.power_series_id"
                      :options="filteredPowerSeriesOptions(index)"
                      :reduce="(val) => val.value"
                      label="text"
                      required
                    />
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <InputCurrency
                        :prepend="''"
                        v-model="trigger.interval"
                        required
                        append="Hours"
                      />
                    </div>
                  </td>
                  <td class="text-center">
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      @click="removeCounterTrigger(index)"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>

        <!-- Job Description -->
        <b-col md="12" class="mt-3">
          <b-form-group label="Job Description">
            <wysiwyg
              :style="{ minHeight: '200px' }"
              v-model="form.job_description"
              placeholder="Describe job here..."
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Buttons -->
      <div class="d-flex justify-content-end mt-4">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          :disabled="loading"
          @click="$emit('close')"
        >
          Cancel & Close
        </b-button>

        <b-button type="submit" variant="primary" :disabled="loading">
          <b-spinner small v-if="loading" class="mr-2"></b-spinner>
          {{ loading ? 'Submitting...' : 'Submit' }}
        </b-button>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import {
  maintenanceActions,
  pmsActions,
  powerActions,
} from '@/src/Utils/helper'

export default {
  components: { InputCurrency },
  props: {
    selectedData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      options: {
        jobType: [],
        equipments: [],
        jobClass: [],
        powerSeries: [],
        powerTypes: [],
        category: [],
      },
      form: {
        code: '',
        is_reset: '',
        name: '',
        method: 'CALENDAR',
        calendar_type: 'MONTH',
        calendar_interval: 1,
        job_description: '',
        maintenance_job_class_id: '',
        maintenance_job_type_id: '',
        power_type_ids: [],
        maintenance_master_id: '',
        remarks: '',
        counter_triggers: [{ power_series_id: null, interval: '' }],
        active: true,
        maintenance_component_id:
          Number(this.$route.query.maintenance_component_id) || null,
      },
    }
  },
  methods: {
    ...maintenanceActions,
    ...pmsActions,
    ...powerActions,
    async fetchCategory() {
      const res = await this.getJobLibrayrCategory({
        page: 1,
        limit: 9999,
      })

      if (res?.status === 'success') {
        const { data } = res.data
        this.options.category = data
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchJobType() {
      const params = {
        page: 1,
        perPage: 1000,
      }
      this.jobTypeList = []
      const res = await this.getJobType(params)

      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.options.jobType = res.data.data
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchJobClass() {
      const params = {
        page: 1,
        perPage: 1000,
      }
      this.jobTypeList = []
      const res = await this.getJobClass(params)

      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.options.jobClass = res.data.data
          if(this.selectedData == null) {
            this.form.maintenance_job_class_id = this.options.jobClass[0]?.id || null
          }
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchPowerSeriess() {
      const params = {
        page: 1,
        perPage: 1000,
      }
      this.jobTypeList = []
      const res = await this.getPowerSeries({ params })

      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.options.powerSeries = res.data.data?.map((el) => ({
            text: `${el.name} - ${el.model}`,
            value: el.id,
          }))
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchPowerTypes() {
      const params = {
        page: 1,
        perPage: 1000,
      }
      this.jobTypeList = []
      const res = await this.getPowerTypes({ params })

      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.options.powerTypes = res.data.data?.map((el) => ({
            text: `${el.name}`,
            value: el.id,
          }))
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    addCounterTrigger() {
      this.form.counter_triggers.push({
        power_series_id: null,
        interval: '',
      })
    },
    removeCounterTrigger(index) {
      this.form.counter_triggers.splice(index, 1)
    },

    filteredPowerSeriesOptions(index) {
      const currentId = this.form.counter_triggers[index]?.power_series_id
      const selectedSet = new Set(
        this.form.counter_triggers
          .map((t, i) => (i === index ? null : t.power_series_id))
          .filter((id) => id !== null && id !== undefined)
      )
      return this.options.powerSeries.filter(
        (opt) => !selectedSet.has(opt.value) || opt.value === currentId
      )
    },

    async fetchMasterEquipment(
      maintenance_component_id = this.$route.query?.maintenance_component_id
    ) {
      const params = {
        limit: 9999,
        page: 1,
        maintenance_component_id,
      }
      const res = await this.getEquipment(params)
      if (res.status === 'success') {
        const { data } = res.data
        this.options.equipments = data
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async handleSubmit() {
      try {
        this.loading = true

        if (this.form.method === 'COUNTER') {
          this.form.calendar_type = 'NONE'
        }

        // Build payload
        const formData = new FormData()

        for (const key in this.form) {
          if (key === 'counter_triggers') {
            // Kombinasi counter_triggers dengan power_type_ids
            let combinedIndex = 0
            this.form.counter_triggers.forEach((item, triggerIndex) => {
              this.form.power_type_ids.forEach((powerTypeId, powerIndex) => {
                formData.append(
                  `counter_triggers[${combinedIndex}][power_series_id]`,
                  item.power_series_id
                )
                formData.append(
                  `counter_triggers[${combinedIndex}][interval]`,
                  item.interval
                )
                formData.append(
                  `counter_triggers[${combinedIndex}][power_type_id]`,
                  powerTypeId
                )
                combinedIndex++
              })
            })
          } else if (key === 'is_reset') {
            if (this.form.maintenance_job_type_id == 12) {
              formData.append(key, this.form[key] ? 1 : 0)
            }
          } else {
            formData.append(key, this.form[key])
          }
        }

        if (this.form.method === 'COUNTER') {
          formData.delete('calendar_interval')
        }

        const endpoint = !this.selectedData
          ? this.createJobLibraries(formData)
          : this.updateJobLibraries({
              id: this.selectedData.id,
              data: formData,
            })
        const res = await endpoint
        if (res.status === 'success') {
          const msg = this.$swal(
            `${this.selectedData ? 'Update' : 'Add'} Data Success!`,
            res.data.message,
            'success'
          )
          this.$emit('refetch')
          this.$emit('close')
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } catch (error) {
        console.log(error)
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    'form.maintenance_component_id'(newVal) {
      if (newVal) {
        this.fetchMasterEquipment(newVal)
      } else {
        // Reset equipment options jika category dikosongkan
        this.options.equipments = []
        this.form.maintenance_master_id = ''
      }
    },
    'form.name'(newVal) {
      // Hanya generate otomatis saat CREATE (ketika selectedData == null/undefined)
      // Jika sedang EDIT, jangan ubah code secara otomatis
      if (this.selectedData && this.selectedData.id) return

      if (!newVal) {
        this.form.code = ''
        return
      }

      // Ambil waktu saat ini
      const now = new Date()
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const year = now.getFullYear()

      // Ambil inisial tiap kata dari name
      const initials = newVal
        .trim()
        .split(/\s+/) // pisah per kata
        .map((word) => word.charAt(0).toUpperCase()) // ambil huruf pertama dan kapital
        .join('')

      // Format akhir: HHMMYYYY-JL-INITIALS
      this.form.code = `${hours}${minutes}${year}-JL-${initials}`
    },
  },

  mounted() {
    this.fetchJobClass()
    this.fetchJobType()
    this.fetchPowerSeriess()
    this.fetchCategory()
    this.fetchPowerTypes()
    if (this.$route.query?.maintenance_component_id) {
      this.fetchMasterEquipment(this.$route.query?.maintenance_component_id)
    }
    if (this.selectedData) {
      this.form.maintenance_component_id =
        this.selectedData.maintenance_component_id
      this.form.code = this.selectedData.code
      this.form.is_reset = this.selectedData.is_reset
      this.form.name = this.selectedData.name
      this.form.method = this.selectedData.method
      this.form.calendar_type = this.selectedData.calendar_type
      this.form.calendar_interval = this.selectedData.calendar_interval
      this.form.job_description = this.selectedData.job_description
      this.form.maintenance_job_class_id =
        this.selectedData.maintenance_job_class_id
      this.form.maintenance_job_type_id =
        this.selectedData.maintenance_job_type_id
      this.form.maintenance_master_id = this.selectedData.maintenance_master_id
      this.form.active = this.selectedData.active
      if (this.selectedData?.job_library_counters?.length) {
        // Ambil semua power_type_id dari job_library_counters dan buat unique
        const powerTypeIds = this.selectedData.job_library_counters
          .map((trigger) => trigger.power_type_id)
          .filter((id) => id !== null && id !== undefined) // hapus null/undefined

        // Buat array unique menggunakan Set
        this.form.power_type_ids = [...new Set(powerTypeIds)]

        // Ambil counter triggers yang unique berdasarkan power_series_id dan interval
        const uniqueCounterTriggers = []
        const seenCombinations = new Set()

        this.selectedData.job_library_counters.forEach((trigger) => {
          const combination = `${trigger.power_series?.id}-${trigger.interval_hour}`
          if (!seenCombinations.has(combination)) {
            seenCombinations.add(combination)
            uniqueCounterTriggers.push({
              power_series_id: trigger.power_series?.id,
              interval: trigger.interval_hour,
            })
          }
        })

        this.form.counter_triggers = uniqueCounterTriggers
      }
    }
  },
}
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
</style>
